"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var UserIcon = function UserIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$filled = _ref.filled,
      filled = _ref$filled === void 0 ? false : _ref$filled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["color", "size", "filled", "className", "children"]);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M11 3a3 3 0 1 1-3-3 3 3 0 0 1 3 3zm0 3H5a2 2 0 0 0-2 2v5a1 1 0 0 0 1 1h1V9h1v6.428a.572.572 0 0 0 .572.572h2.856a.572.572 0 0 0 .572-.572V9h1v5h1a1 1 0 0 0 1-1V8a2 2 0 0 0-2-2z"
    }) : _react["default"].createElement("path", {
      d: "M3 11.5V15h10v-3.5A3.504 3.504 0 0 0 9.5 8h-3A3.504 3.504 0 0 0 3 11.5zM6.5 9h3a2.503 2.503 0 0 1 2.5 2.5V14H4v-2.5A2.503 2.503 0 0 1 6.5 9zm4.3-5A2.8 2.8 0 1 0 8 6.8 2.803 2.803 0 0 0 10.8 4zM6.133 4A1.867 1.867 0 1 1 8 5.867 1.869 1.869 0 0 1 6.133 4z"
    }));
  }

  if (size <= 24) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M16 4a4 4 0 1 1-4-4 4 4 0 0 1 4 4zm.75 4h-9.5A2.25 2.25 0 0 0 5 10.25v9.25A1.5 1.5 0 0 0 6.5 21H7v-9h1v11.25a.75.75 0 0 0 .75.75h6.5a.75.75 0 0 0 .75-.75V12h1v9h.5a1.5 1.5 0 0 0 1.5-1.5v-9.25A2.25 2.25 0 0 0 16.75 8z"
    }) : _react["default"].createElement("path", {
      d: "M7.2 5.5a4.3 4.3 0 1 0 4.3-4.3 4.305 4.305 0 0 0-4.3 4.3zm7.644 0A3.344 3.344 0 1 1 11.5 2.156 3.348 3.348 0 0 1 14.844 5.5zM14.5 11h-6A5.506 5.506 0 0 0 3 16.5V22h17v-5.5a5.506 5.506 0 0 0-5.5-5.5zM19 21H4v-4.5A4.505 4.505 0 0 1 8.5 12h6a4.505 4.505 0 0 1 4.5 4.5z"
    }));
  }

  return _react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), filled ? _react["default"].createElement("path", {
    d: "M21.064 5a5 5 0 1 1-5-5 5 5 0 0 1 5 5zM22 11H10a3 3 0 0 0-3 3v12a2 2 0 0 0 2 2h1V15h1v16a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V15h1v13h1a2 2 0 0 0 2-2V14a3 3 0 0 0-3-3z"
  }) : _react["default"].createElement("path", {
    d: "M20.5 15h-9A6.508 6.508 0 0 0 5 21.5V30h22v-8.5a6.508 6.508 0 0 0-6.5-6.5zM26 29H6v-7.5a5.506 5.506 0 0 1 5.5-5.5h9a5.506 5.506 0 0 1 5.5 5.5zM16 13.8A5.8 5.8 0 1 0 10.2 8a5.806 5.806 0 0 0 5.8 5.8zm0-10.633A4.833 4.833 0 1 1 11.167 8 4.839 4.839 0 0 1 16 3.167z"
  }));
};

var _default = UserIcon;
exports["default"] = _default;